import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { IAppServiceLanguages } from '@app/app.interface';
import { AppService } from '@app/app.service';
import { IOutputEventData } from '@components/buttons-panel/buttons-panel.interface';
import { LANG_DICTIONARY_TOKEN } from '@constants/diConstant';
import { LangService } from '@services/lang.service';
import { IInputButton } from './panel-tools.interfaces';

/** Компонент - панель управления */
@Component({
    selector: 'panel-tools',
    templateUrl: './panel-tools.component.html',
    styleUrls: ['./panel-tools.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PanelToolsComponent {
    readonly langService = inject(LangService);
    readonly appService = inject(AppService);
    readonly dictionary = inject(LANG_DICTIONARY_TOKEN);

    /** Флаг отображения кнопки переключения языков */
    @Input() showLangButton: boolean = false;

    /** Ссылка на веб-рездел инструкций отображения кнопки помощи */
    @Input() helpLink: string;

    /** Флаг отображение Указателя обязательных полей */
    @Input() showRequiredLabel: boolean = false;

    /** Флаг отображение Крестика для закрытия */
    @Input() showCloseButton: boolean = false;

    /** Высота ВСЕХ кнопок в панели (общая) */
    @Input() buttonsHeight?: string = 'slim';

    /** Настройки кнопки выпадающего меню */
    @Input() buttonMenuConfig?: {
        color: string;
        borderRadius: string;
    };

    /** Высота Настройки кнопки помощи */
    @Input() helpButtonConfig?: {
        color: string;
        borderRadius: string;
    };

    /** Флаг фиксации панели при прокрутку */
    @Input() isSticky: boolean = true;

    /** Тип панели инструментов */
    @Input() isPanelToolsDialog: boolean = false;

    /** Набор кнопок */
    @Input() public buttons?: IInputButton = { global: [], globalMenu: [] };

    /** Данные о родителе */
    @Input() itemData: { [key: string]: any } = {};

    /** Общее событие для кликов */
    @Output() panelClick = new EventEmitter<IOutputEventData<any>>();

    /** Переключение языка */
    @Output() setCurrentLangForm = new EventEmitter<any>();

    /** Текущий язык формы */
    public currentLangForm = this.langService.languages[this.langService.currentLanguage];

    /** Пользователь выбрал новый язык в выпадашке */
    changeLangForm(lang: IAppServiceLanguages): void {
        this.currentLangForm = lang;
        this.setCurrentLangForm.emit(lang);
    }

    /**
     * Вызов родительской функции
     * @param type тип
     * @param value значение
     * @param event событие нажатия
     */
    callParent(type, value): void {
        this.panelClick.next({ name: type, data: value });
        return;
    }

    /** Отслеживание изменеий для списка кнопок по иконке */
    public trackByIcon = (item) => item.icon;

    /** Отслеживание изменеий для списка кнопок по клику (действию) */
    public trackByAction = (item) => item.click;
}
